/** Shared EasyDropTaxi Driver App support details from the website project. */
export const DRIVER_APP_NAME = 'EasyDropTaxi Driver';

export const DRIVER_SUPPORT = {
  phoneDisplay: '+91 9629954544',
  phoneTel: 'tel:+919629954544',
  email: 'support@easydroptaxi.com',
  mailto: 'mailto:support@easydroptaxi.com',
  whatsappNumber: '919629954544',
  address: 'Coimbatore, Tamil Nadu, India',
};

export const DRIVER_ROUTES = {
  privacy: '/driver-privacy-policy',
  terms: '/driver-terms',
  dataDeletion: '/driver-data-deletion',
  support: '/driver-support',
};
